import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=3f7e2b44&scoped=true"
import script from "./Loader.vue?vue&type=script&lang=js"
export * from "./Loader.vue?vue&type=script&lang=js"
import style0 from "./Loader.vue?vue&type=style&index=0&id=3f7e2b44&prod&scoped=true&lang=css"
import style1 from "./Loader.vue?vue&type=style&index=1&id=3f7e2b44&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7e2b44",
  null
  
)

export default component.exports